export default "__VITE_ASSET__BUmIN34H__"